<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<div class="tab_box">
				<van-tabs
					v-model="nowIndex"
					color="#7494F6"
					title-active-color="#7494F6"
					sticky
					swipeable
					line-width="1.6rem"
				>
					<van-tab title="我的公司">
						<div v-if="companyData.length > 0" class="list_box">
							<div v-for="(value, index) in companyData" :key="index" class="box_el">
								<div class="title">{{ value.name }}</div>
								<div class="btn_box" @click="removeBind(value)">解绑</div>
							</div>
						</div>
						<div v-else>
							<van-empty image="search" description="暂未查询到相关记录" />
						</div>
					</van-tab>
					<van-tab title="我的社区">
						<div v-if="communityData.length > 0" class="list_box">
							<div v-for="(value, index) in communityData" :key="index"class="box_el">
								<div class="title">{{ value.name }}</div>
								<div class="btn_box" @click="removeBind(value)">解绑</div>
							</div>
						</div>
						<div v-else>
							<van-empty image="search" description="暂未查询到相关记录" />
						</div>
					</van-tab>
				</van-tabs>
			</div>
		</div>
		<!--页面开始-->
	    <!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { msgList, msgRemoveBind } from '@/api/public'
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			nowIndex: 0,
			companyData: [],
			communityData: [],
			isLoading: true,
		}
	},
	created(){
		let that = this;
		if(!localStorage.getItem('token')) {
			this.$router.push({path:'/login'});
		}else {
			that.getListData();
		}
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		//请求社区地址
		getListData() {
			let that = this;
			msgList().then(res => {
				that.companyData = res.data.company;
				that.communityData = res.data.community;
				that.isLoading = false;
			});
		},
		//解绑
		removeBind(value) {
			let that = this;
			that.$dialog.confirm({
				title: '提示',
				message: '您确定要解除与 ' + value.name + ' 的绑定吗？',
				confirmButtonText: '取消',
				cancelButtonText: '确定',
				confirmButtonColor: '#333333',
			}).then(() => {
				//点击关闭
			}).catch(() => {
				msgRemoveBind({
					id: value.id,
				}).then(res => {
					that.$toast('解绑成功');
					that.getListData();
				});
			});
		},
	},
	beforeDestroy() {
		//
	}
}
</script>
</script>

<style scoped>
.tab_box{
	padding: 0.4rem 0rem;
}

.list_box{
	padding-top: 0.5rem;
	padding-bottom: 1rem;
}
.list_box .box_el{
	display: flex;
	height: 1.4rem;
	line-height: 1.4rem;
	border-bottom: 1px solid #f8f8f8;
}
.list_box .box_el .title{
	flex: 1;
	padding-left: 0.5rem;
	overflow:hidden;
	text-overflow:ellipsis;
	display:-webkit-box;
	-webkit-box-orient:vertical;
	-webkit-line-clamp:1;
}
.list_box .box_el .btn_box{
	width: 2rem;
	text-align: center;
	color: #ff976a;
}
</style>
